import { Component, HostBinding } from "@angular/core";

@Component({
    selector: 'abb-page-not-found',
    standalone: true,
    imports: [],
    template: `
        <h2>Page not found</h2>
    `,
    styles: ``,
  })
  export class PageNotFoundComponent {
    @HostBinding('attr.id') componentid = 'page-not-found-component';
  }